export default {
  allowedMethods: [],
  collections: [],
  requests: [],
  requestState: 0, // 0 - initial, 1 - request sent, 2 - response ok, 3 - response w/ error
  requestStartTime: 0,
  requestEndTime: 0,
  response: null
};